import React, { useMemo } from "react";
import { Navigate } from "react-router-dom";
import { AppModule } from "@/enums/AppModule";
import { useAppContext } from "@/contexts/AppContext";
import useEnvironment from "@/hooks/useEnvironment";

const modulePathMap: Record<AppModule, string> = {
  [AppModule.DemandForecast]: "/demand-forecast",
  [AppModule.AllocationCheckList]: "/allocation-check",
  [AppModule.UsageForecast]: "/forecasts",
  [AppModule.RetinaForecast]: "/retina-forecast",
};

const ModuleRedirect: React.FC = () => {
  const { availableModules } = useAppContext();
  const { isProd, isLoading } = useEnvironment();

  const defaultPath = useMemo(() => {
    if (availableModules.includes(AppModule.DemandForecast)) {
      return modulePathMap[AppModule.DemandForecast];
    }

    if (availableModules.includes(AppModule.AllocationCheckList)) {
      return modulePathMap[AppModule.AllocationCheckList];
    }

    if (!isProd && availableModules.includes(AppModule.UsageForecast)) {
      return modulePathMap[AppModule.UsageForecast];
    }

    if (availableModules.includes(AppModule.RetinaForecast)) {
      return modulePathMap[AppModule.RetinaForecast];
    }

    return null;
  }, [availableModules, isProd]);

  if (isLoading) {
    return null;
  }

  if (!defaultPath) {
    return null;
  }

  return <Navigate to={defaultPath} replace />;
};

export default ModuleRedirect;
